[
  {
    "code": "VN-44",
    "name": "An Giang"
  },
  {
    "code": "VN-43",
    "name": "Ba Ria-Vung Tau"
  },
  {
    "code": "VN-54",
    "name": "Bac Giang"
  },
  {
    "code": "VN-53",
    "name": "Bac Kan"
  },
  {
    "code": "VN-55",
    "name": "Bac Lieu"
  },
  {
    "code": "VN-56",
    "name": "Bac Ninh"
  },
  {
    "code": "VN-50",
    "name": "Ben Tre"
  },
  {
    "code": "VN-31",
    "name": "Binh Dinh"
  },
  {
    "code": "VN-57",
    "name": "Binh Duong"
  },
  {
    "code": "VN-58",
    "name": "Binh Phuoc"
  },
  {
    "code": "VN-40",
    "name": "Binh Thuan"
  },
  {
    "code": "VN-59",
    "name": "Ca Mau"
  },
  {
    "code": "VN-48",
    "name": "Can Tho, thanh pho"
  },
  {
    "code": "VN-04",
    "name": "Cao Bang"
  },
  {
    "code": "VN-60",
    "name": "Da Nang, thanh pho"
  },
  {
    "code": "VN-33",
    "name": "Dak Lak"
  },
  {
    "code": "VN-72",
    "name": "Dak Nong"
  },
  {
    "code": "VN-71",
    "name": "Dien Bien"
  },
  {
    "code": "VN-39",
    "name": "Dong Nai"
  },
  {
    "code": "VN-45",
    "name": "Dong Thap"
  },
  {
    "code": "VN-30",
    "name": "Gia Lai"
  },
  {
    "code": "VN-03",
    "name": "Ha Giang"
  },
  {
    "code": "VN-63",
    "name": "Ha Nam"
  },
  {
    "code": "VN-64",
    "name": "Ha Noi, thanh pho"
  },
  {
    "code": "VN-15",
    "name": "Ha Tay"
  },
  {
    "code": "VN-23",
    "name": "Ha Tinh"
  },
  {
    "code": "VN-61",
    "name": "Hai Duong"
  },
  {
    "code": "VN-62",
    "name": "Hai Phong, thanh pho"
  },
  {
    "code": "VN-73",
    "name": "Hau Giang"
  },
  {
    "code": "VN-14",
    "name": "Hoa Binh"
  },
  {
    "code": "VN-66",
    "name": "Hung Yen"
  },
  {
    "code": "VN-34",
    "name": "Khanh Hoa"
  },
  {
    "code": "VN-47",
    "name": "Kien Giang"
  },
  {
    "code": "VN-28",
    "name": "Kon Tum"
  },
  {
    "code": "VN-01",
    "name": "Lai Chau"
  },
  {
    "code": "VN-35",
    "name": "Lam Dong"
  },
  {
    "code": "VN-09",
    "name": "Lang Son"
  },
  {
    "code": "VN-02",
    "name": "Lao Cai"
  },
  {
    "code": "VN-41",
    "name": "Long An"
  },
  {
    "code": "VN-67",
    "name": "Nam Dinh"
  },
  {
    "code": "VN-22",
    "name": "Nghe An"
  },
  {
    "code": "VN-18",
    "name": "Ninh Binh"
  },
  {
    "code": "VN-36",
    "name": "Ninh Thuan"
  },
  {
    "code": "VN-68",
    "name": "Phu Tho"
  },
  {
    "code": "VN-32",
    "name": "Phu Yen"
  },
  {
    "code": "VN-24",
    "name": "Quang Binh"
  },
  {
    "code": "VN-27",
    "name": "Quang Nam"
  },
  {
    "code": "VN-29",
    "name": "Quang Ngai"
  },
  {
    "code": "VN-13",
    "name": "Quang Ninh"
  },
  {
    "code": "VN-25",
    "name": "Quang Tri"
  },
  {
    "code": "VN-65",
    "name": "Sai Gon"
  },
  {
    "code": "VN-52",
    "name": "Soc Trang"
  },
  {
    "code": "VN-05",
    "name": "Son La"
  },
  {
    "code": "VN-37",
    "name": "Tay Ninh"
  },
  {
    "code": "VN-20",
    "name": "Thai Binh"
  },
  {
    "code": "VN-69",
    "name": "Thai Nguyen"
  },
  {
    "code": "VN-21",
    "name": "Thanh Hoa"
  },
  {
    "code": "VN-26",
    "name": "Thua Thien-Hue"
  },
  {
    "code": "VN-46",
    "name": "Tien Giang"
  },
  {
    "code": "VN-51",
    "name": "Tra Vinh"
  },
  {
    "code": "VN-07",
    "name": "Tuyen Quang"
  },
  {
    "code": "VN-49",
    "name": "Vinh Long"
  },
  {
    "code": "VN-70",
    "name": "Vinh Phuc"
  },
  {
    "code": "VN-06",
    "name": "Yen Bai"
  }
]